import { useEffect } from "react";
import { TextField, MenuItem } from "@mui/material";
import useContainerOptions from "../hooks/useContainerOptions";

export default function ContainerOptionSelector({
  value,
  onChange,
  hiddenLabel = false,
}) {
  const options = useContainerOptions();

  useEffect(() => {
    if (!options.length || !value) return;

    const exists = options.some((opt) => opt.value === value);

    if (!exists) onChange("");
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [value, options]);

  return (
    <TextField
      select
      size="small"
      label={hiddenLabel ? "" : "Container"}
      fullWidth
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      disabled={!options.length}
    >
      <MenuItem value="">
        —
      </MenuItem>

      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </TextField>
  );
}

